import { takeCustomLatest } from 'state/common/common.effects'
import { tagFilterDrawerActions } from 'state/new-summary/root-drawers/tag-filter/tag-filter.actions'
import { createNewListDrawerActions } from './create-new-list.actions'
import {
  handleAssignedInventoriesEffects,
  setFilterEntityByLabelKeyValsEffects
} from './create-new-list.effects'

function* handleAssignedInventoriesSaga() {
  yield takeCustomLatest(
    createNewListDrawerActions.UPDATE_INVENTORY_ASSIGNMENT_ACTION,
    handleAssignedInventoriesEffects
  )
}

// function* setFilterEntityByLabelKeyValsSaga() {
//   yield takeCustomLatest(
//     tagFilterDrawerActions.FILTER_ENTITY_BY_LABEL_KEY_VALS,
//     setFilterEntityByLabelKeyValsEffects
//   )
// }

export const CreateNewListWatchers = [handleAssignedInventoriesSaga()]
